import { styled, Typography, useTheme } from '@mui/material';

import { typographyToSystem } from '../../theme/typography';

import type { ChkOptionLabelProps } from './ChkOptionLabel.types';

export const ChkOptionLabel = ({
  title,
  description,
  icon,
  ...rest
}: ChkOptionLabelProps) => {
  const theme = useTheme();

  return (
    <OptionWrapper {...rest}>
      <TextWrapper>
        <Title>{title}</Title>
        <Description>{description}</Description>
      </TextWrapper>
      {!theme.zoom.isElevatedZoom && icon}
    </OptionWrapper>
  );
};

const OptionWrapper = styled('div')({
  display: 'flex',
  alignItems: 'space-between',
});

const TextWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  alignItems: 'flex-start',
  textAlign: 'left',
});

const Title = styled(Typography)(({ theme }) => ({
  ...theme.typography.body1,
  fontWeight: theme.typography.fontWeightMedium,
  color: theme.tokens.optionCardsValueHeader,
  letterSpacing: 0,
}));

const Description = styled(Typography)(({ theme }) => ({
  ...typographyToSystem(theme.typography.body3),
  fontWeight: theme.typography.fontWeightRegular,
  color: theme.tokens.optionCardsValueBody,
  letterSpacing: 0,
}));
